module.exports = "# 什么是mvvm\n_mvvm说简单一点，就是数据驱动视图，不再去使用dom操作来处理页面_\n\n使用数据去驱动视图的非常好的好处就是\n- 页面不再需要一大堆的dom操作js，页面上的逻辑代码可以进一步的分离出来\n- 页面和数据绑定，数据和逻辑绑定，有效的解耦，使得页面的复用性大大增加\n- **十分有效的减少**了前端的不必要的工作量，当视图逻辑写好之后，只需要去改变数据，页面就会自动更新\n\n举个栗子\n```\n// 使用mvvm\nlet data = '测试数据0';\n<div>{{ data }}</div>\n// 渲染后的结果\n<div>测试数据0</div>\n// 当我想要把数据改成<测试数据1>时\n// 只需要\ndata = '测试数据1';\n// 页面就会自动响应更新成\n<div>测试数据1</div>\n```\n(造轮子狂魔笑了)\n\n## lies框架\n_经过我潜心研究多年，终于在掌握了mvvm原理的情况下，造出了一个框架_"


//////////////////
// WEBPACK FOOTER
// ./src/store/mvvm.md
// module id = 153
// module chunks = 2